import Main from '@/components/Main'
import Wrapper from '@/components/Wrapper'
import Dashboard from '@/views/dashboard/Dashboard'
import Login from '@/views/loginManage/Login'
import ForgetPassword from '@/views/loginManage/ForgetPassword'
import Register from '@/views/loginManage/Register'

import ProjectOrderWrapper from '@/views/advertisement/ProjectOrderWrapper'
import ProjectOrderIndex from '@/views/advertisement/order/ProjectOrderIndex'
import AdServingManageIndex from '@/views/advertisement/schedule/AdServingManageIndex'
import MaterialCreativeIndex from '@/views/advertisement/creative/MaterialCreativeIndex'
import MaterialManageIndex from '@/views/advertisement/material/MaterialManageIndex'
import LandingPageIndex from '@/views/advertisement/landingPage/LandingPageIndex'
import MaterialManageAdd from '@/views/advertisement/material/MaterialManageAdd'

// 数据报表
import DataReportWrapper from '@/views/dataReport/DataReportWrapper'
import OrderBasicData from '@/views/dataReport/OrderBasicData'
import AudienceData from '@/views/dataReport/AudienceData'
import FrequencyData from '@/views/dataReport/FrequencyData'
import AreaData from '@/views/dataReport/AreaData'
import ResultsData from '@/views/dataReport/ResultsData'

// 财务管理
import FinancialIndex from '@/views/financialManagement/FinancialIndex'
// 账号管理
import LoginAccountInfo from '@/views/accountManagement/LoginAccountInfo'
import EntityQualification from '@/views/accountManagement/EntityQualification'
import CollaborationAccount from '@/views/accountManagement/CollaborationAccountIndex'
import AdvertiserManage from '@/views/accountManagement/AdvertiserManageIndex'
import AdvertiserAccountManage from '@/views/accountManagement/AdvertiserAccountManageIndex'
import BatchOrderIndex from '@/views/adBatch/BatchOrderIndex'
// 素材工厂
import WorkbagWrapper from '@/views/mediaFactory/components/MediaWrapper.vue'
import MediaIndex from '@/views/mediaFactory/media/MediaIndex.vue'
import MaterialIndex from '@/views/materialPackage/MaterialIndex.vue'
import RegionEditor from '@/views/regionEditor/Index.vue'
import MessageBox from '@/views/message/index.vue'
import DirectPackage from '@/views/directPackage/index.vue'
import ChangeLog from '@/views/ChangeLog.vue'

const children = [
  {
    name: 'dashboard',
    path: 'dashboard',
    component: Dashboard,
    meta: {
      tagId: 'dashboard',
      title: '首页',
      parentPath: 'dashboard'
    }
  },
  {
    name: 'advertisement',
    path: 'advertisement',
    component: ProjectOrderWrapper,
    meta: { title: '广告投放' },
    children: [
      {
        name: 'projectOrder',
        path: '/advertisement/projectOrder/view.html',
        component: ProjectOrderIndex,
        props: true,
        meta: {
          tagId: 'projectOrder',
          title: '项目订单',
          parentPath: 'advertisement'
        }
      },
      {
        name: 'adServingManage',
        path: '/advertisement/adServingManage/view.html',
        component: AdServingManageIndex,
        meta: {
          tagId: 'adServingManage',
          title: '投放管理',
          parentPath: 'advertisement'
        }
      },
      {
        name: 'materialCreative',
        path: '/advertisement/materialCreative/view.html',
        component: MaterialCreativeIndex,
        meta: {
          tagId: 'materialCreative',
          title: '素材创意',
          parentPath: 'advertisement'
        }
      },
      {
        name: 'materialManage',
        path: '/advertisement/materialManage/view.html',
        component: MaterialManageIndex,
        meta: {
          tagId: 'materialManage',
          title: '素材库',
          parentPath: 'advertisement'
        }
      },
      {
        name: 'landingPage',
        path: '/advertisement/landingPage/view.html',
        component: LandingPageIndex,
        meta: {
          tagId: 'landingPage',
          title: '落地页',
          parentPath: 'advertisement'
        }
      },
      {
        name: 'materialAdd',
        path: '/advertisement/materialManage/create.html',
        component: MaterialManageAdd,
        meta: {
          tagId: 'materialAdd',
          title: '创建素材',
          parentPath: 'advertisement'
        }
      },
      {
        name: 'batchOrder',
        path: '/adBatch/BatchOrder/view.html',
        component: BatchOrderIndex,
        meta: {
          tagId: 'batchOrder',
          title: '批量建单',
          hideInMenu: true
        }
      }
    ]
  },
  {
    name: 'dataReport',
    path: 'dataReport',
    component: DataReportWrapper,
    meta: { title: '数据报表' },
    children: [
      {
        name: 'orderBasicData',
        path: '/dataReport/orderBasicData/view.html',
        component: OrderBasicData,
        props: true,
        meta: {
          tagId: 'orderBasicData',
          title: '订单基础数据',
          parentPath: 'dataReport'
        }
      },
      {
        name: 'areaData',
        path: '/dataReport/areaData/view.html',
        component: AreaData,
        meta: {
          tagId: 'areaData',
          title: '地域数据',
          parentPath: 'dataReport'
        }
      },
      {
        name: 'audienceData',
        path: '/dataReport/audienceData/view.html',
        component: AudienceData,
        props: true,
        meta: {
          tagId: 'audienceData',
          title: '受众人群',
          parentPath: 'dataReport'
        }
      },
      {
        name: 'frequencyData',
        path: '/dataReport/frequencyData/view.html',
        component: FrequencyData,
        meta: {
          tagId: 'frequencyData',
          title: '频次到达',
          parentPath: 'dataReport'
        }
      }
      // ,
      // {
      //   name: 'resultsData',
      //   path: '/dataReport/resultsData/view.html',
      //   component: ResultsData,
      //   meta: {
      //     tagId: 'resultsData',
      //     title: '效果数据',
      //     parentPath: 'dataReport'
      //   }
      // }
    ]
  },
  {
    name: 'financialManagement',
    path: 'financialManagement',
    component: Wrapper,
    meta: { title: '财务管理' },
    children: [
      {
        name: 'financialIndex',
        path: '/financialManagement/financialIndex/view.html',
        component: FinancialIndex,
        meta: {
          tagId: 'FinancialIndex',
          title: '交易记录',
          parentPath: 'financialManagement'
        }
      }
    ]
  },
  {
    name: 'accountManagement',
    path: 'accountManagement',
    component: Wrapper,
    meta: { title: '账号管理', icon: 'el-icon-user' },
    children: [
      {
        name: 'loginAccountInfo',
        path: '/accountManagement/loginAccountInfo/view.html',
        component: LoginAccountInfo,
        meta: {
          tagId: 'loginAccountInfo',
          title: '登录账号信息',
          parentPath: 'accountManagement'
        }
      },
      {
        name: 'collaborationAccount',
        path: '/accountManagement/collaborationAccount/view.html',
        component: CollaborationAccount,
        meta: {
          tagId: 'collaborationAccount',
          title: '协作账号管理',
          parentPath: 'accountManagement'
        }
      },
      {
        name: 'entityQualification',
        path: '/accountManagement/entityQualification/view.html',
        component: EntityQualification,
        meta: {
          tagId: 'entityQualification',
          title: '主体资质管理',
          parentPath: 'accountManagement'
        }
      },
      {
        name: 'advertiserManage',
        path: '/accountManagement/advertiserManage/view.html',
        component: AdvertiserManage,
        meta: {
          tagId: 'advertiserManage',
          title: '广告主管理',
          parentPath: 'accountManagement'
        }
      },
      {
        name: 'advertiserAccountManage',
        path: '/accountManagement/advertiserAccountManage/view.html',
        component: AdvertiserAccountManage,
        meta: {
          tagId: 'advertiserAccountManage',
          title: '广告主账号管理',
          parentPath: 'accountManagement'
        }
      }
    ]
  },
  {
    name: 'Workbag',
    path: 'workbag',
    component: WorkbagWrapper,
    meta: { title: '素材工厂', icon: 'el-icon-user' },
    children: [
      {
        name: 'mediaIndex',
        path: '/workbag/mediaIndex/view.html',
        component: MediaIndex,
        meta: { tagId: 'materialIndex', title: '物料', parentPath: 'workbag' }
      },
      {
        name: 'materialPackage',
        path: '/workbag/materialPackage/view.html',
        component: MaterialIndex,
        meta: {
          tagId: 'materialList',
          title: '物料列表',
          parentPath: 'workbag'
        }
      },
      {
        name: 'regionEditor',
        path: '/workbag/regionEditor/view.html',
        component: RegionEditor,
        meta: {
          tagId: 'regionEditor',
          title: '区域编辑器',
          parentPath: 'workbag'
        }
      },
      {
        name: 'message',
        path: '/message.html',
        component: MessageBox,
        meta: {
          tagId: 'message',
          title: '物料列表',
          parentPath: 'workbag'
        }
      },
      {
        name: 'directPackage',
        path: '/directPackage.html',
        component: DirectPackage,
        meta: {
          tagId: 'directPackage',
          title: '定向包',
          parentPath: 'workbag'
        }
      }
    ]
  }
]

const routes = [
  {
    path: '/',
    component: Main,
    redirect: '/dashboard',
    children
  },
  {
    name: 'login',
    path: '/login',
    component: Login,
    meta: { title: '登录' }
  },
  {
    name: 'forgetPassword',
    path: '/additional/forgetPassword',
    component: ForgetPassword,
    meta: { title: '忘记密码' }
  },
  {
    name: 'register',
    path: '/additional/register',
    component: Register
  },
  {
    name: 'changelog',
    path: '/changelog',
    component: ChangeLog,
    meta: { title: '更新日志' }
  }
]

export default routes
